module.exports = __webpack_public_path__ + "img/down4-en.25a2d552.png";